// @flow

import React from "react";

import InvestmentRealEstateNew from "./InvestmentRealEstateNew";
import InvestmentRealEstatePurchase from "./InvestmentRealEstatePurchase";
import InvestmentRealEstateReconstruction from "./InvestmentRealEstateReconstruction";

import {
  REAL_ESTATE__NEW_BUILDING,
  REAL_ESTATE__PURCHASE,
  REAL_ESTATE__RECONSTRUCTION,
  REAL_ESTATE_PROJECT
} from "./formFields";

import { type InvestmentSectionProps } from "../../types/details";

const investmentTypes = {
  [REAL_ESTATE__NEW_BUILDING]: InvestmentRealEstateNew,
  [REAL_ESTATE__PURCHASE]: InvestmentRealEstatePurchase,
  [REAL_ESTATE__RECONSTRUCTION]: InvestmentRealEstateReconstruction
};

type InvestmentRealEstateProps = {
  kind: "new_building" | "purchase" | "reconstruction",
  isLocked: boolean
};

const InvestmentRealEstate = ({
  initialValues,
  kind,
  handleSubmit,
  isLocked
}: InvestmentSectionProps & InvestmentRealEstateProps) => {
  const InvestmentType = investmentTypes[initialValues[REAL_ESTATE_PROJECT]];

  return (
    <InvestmentType
      kind={kind}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      isLocked={isLocked}
    />
  );
};

export default InvestmentRealEstate;
